// extracted by mini-css-extract-plugin
module.exports = {"summary":"StaticDatePicker_summary__UGVxM","footer":"StaticDatePicker_footer__dVY6_","picker-sunday":"StaticDatePicker_picker-sunday__nL3FD"};